export const API_BASE_URL_ENV = () => {
	return "https://back.hrteknulugy.online/api/v1";
};
